import { BasementFields, syntaxFNMA } from '@aloft/toolkit-shared';

import { extractAdjustmentDescription } from './extractAdjustmentDescription.ts';

export function extractBasement(sale: Element): BasementFields {
  try {
    const { total, finished } = syntaxFNMA.basementLine1Syntax.decode(
      extractAdjustmentDescription(sale, 'BasementArea') ?? '',
    );
    const { fullBathCount, halfBathCount } = syntaxFNMA.basementLine2Syntax.decode(
      extractAdjustmentDescription(sale, 'BasementFinish') ?? '',
    );

    return {
      hasFeature: true,
      finishedArea: finished?.toJSON(),
      totalArea: total?.toJSON(),
      fullBaths: fullBathCount,
      halfBaths: halfBathCount,
    };
  } catch (e: unknown) {
    console.warn('Failed to parse basement', e);
    return {
      hasFeature: false,
    };
  }
}
